import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const apiId = 'appVersion';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [appData, setAppData] = useState<any>();
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        })

        fetchApi.GET(defaultService,
            {
                apiId: 'app',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAppData(res.data);
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        displayOptions: {
            width: 1380
        },
        dateOptions: {
            columnNames: ['releaseDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={8}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="应用"
                                    name="appId"
                                    rules={[{ required: true, message: '请选择应用!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="应用"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(appData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="版本"
                                    name="versionName"
                                    rules={[{ required: true, message: '版本!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="发布日期"
                                    name="releaseDate"
                                    tooltip='版本发布日期'>
                                    <DatePicker
                                        format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="排序"
                                    name="sorting">
                                    <InputNumber style={{ width: 50 }} />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="默认"
                                    name="isDefault"
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            label=""
                            name="changelog">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`${apiId}${id}`}
                                title='更新说明'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 500 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;